import React from 'react';

const ViewModeSwitch = ({ value, onChange }) => {
  return (
    <div className="d-flex align-items-center" style={{ gap: 8 }}>
      <label className="me-2">Режим:</label>
      <select
        className="form-select"
        style={{ width: 220 }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="positions">По позициям</option>
        <option value="orders">По заказам</option>
        <option value="supplies">По поставкам</option>
      </select>
    </div>
  );
};

export default ViewModeSwitch;
